import React from "react";
import "../About/About.css";

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <h1 className="about-heading">Pan Oasis Ultra Luxury Tower </h1>
        <div className="about-content">
          <div className="ff">
            <div className="fa">
              <h4>Overview</h4>
              <ul className="overview-list">
                <li>Only 256 Ultra-Luxurious Flats</li>
                <li>Floors: 32</li>
                <li>Surrounded By Abundant Lush Green Area</li>
                <li>3-Side Open Plot, Surrounded by Villas (No High-Rises Around)</li>
                <li>Prime Location: Few Minutes’ Walk from Metro Stations, Schools, Hospitals</li>
                <li>Construction Using Advanced Mivan Technique</li>
                <li>Terrace Garden at the Top</li>
                <li>Separate Double-Height Entrance Lobby and Club Area</li>
              </ul>
            </div>
            <div className="fa2">
              <h4>Living/Dining Room</h4>
              <ul>
                <li>Flooring: Italian Marble</li>
                <li>Ceiling Height: ~11.5 Feet</li>
                <li>Doors: Height of 8 Feet</li>
                <li>Air Conditioning: VRV System</li>
                <li>Furnishings: Luxury Furnishings Included</li>
              </ul>
            </div>
          </div>
          <div className="ff">
            <div className="fa3">
              <h4>Master Bedroom</h4>
              <ul>
                <li>Flooring: Laminated Wooden Finish</li>
                <li>Ceiling: POP Finished</li>
                <li>Furnishings: High-End Wardrobes and Fixtures</li>
              </ul>
            </div>
            <div className="fa4">
              <h4>Kitchen</h4>
              <ul>
                <li>Flooring: Italian Marble</li>
                <li>Design: Fully Modular with Top-Brand Fittings (e.g., Kohler or Equivalent)</li>
                <li>Utility: Kitchen Garden Included</li>
                <li>Appliances: All Modern Amenities Included</li>
              </ul>
            </div>
          </div>
          <div className="ff">
            <div className="fa5">
              <h4>Bathrooms</h4>
              <ul>
                <li>Sanitary Ware: World-Class Chinaware</li>
                <li>Walls: Designer Ceramic Tiles Up to 7ft</li>
                <li>Floors: Anti-Skid Ceramic Tiles</li>
                <li>Extras: Granite Vanity Counter</li>
                <li>Bathtub (Optional)</li>
              </ul>
            </div>
            <div className="fa6">
              <h4>Amenities</h4>
              <ul>
                <li>Terrace Garden at the Top</li>
                <li>Clubhouse with Swimming Pool, Gym, and More</li>
                <li>Only 2 Flats per Floor for Ultimate Privacy</li>
                <li>Separate Double-Height Entrance Lobby</li>
                <li>Surrounded by Villas for Peaceful Living</li>
              </ul>
            </div>
          </div>
          <div className="ff">
            <div className="fa7">
              <h4>Additional Highlights</h4>
              <ul>
                <li>Luxury Furnishings Included</li>
                <li>Kitchen Garden for Sustainable Living</li>
                <li>High-End Fittings and Fixtures</li>
                <li>Prime Connectivity to Metro Stations, Schools, and Hospitals</li>
                <li>Spacious Layout with ~11.5 Feet Ceiling Height</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
